export function AppMintedUpcPicker() {
  return (
    <section>
      <div id="minted-modal-container">
        <div id="minted-modal">
          <div id="minted-grid-container"></div>
        </div>
        <div id="minted-submit-container">
          <button type="button">Submit</button>
        </div>
      </div>
    </section>
  );
}
